module.exports = __webpack_public_path__ + "static/media/care_health_logo_with_caption.c3e7eddf.svg";